import { Grid } from '@mui/material';
import { HSpacer, VSpacer } from '@nx-smartmonkey/ui';
import React from 'react';

import InfoIcon from '../assets/img/info-icon.svg';
import VideosIconSvg from '../assets/img/videos_icon.svg';
import Text from '../react-components/Text';

type HeaderContentProps = {
  titleIntlId?: string;
  titleIntlValues?: Record<string, any>;
  subtitle?: string;
  article?: { intlId: string; link?: string; onClick?: () => void };
  video?: { intlId: string; link?: string; onClick?: () => void };
  styles?: {
    container?: React.CSSProperties;
    title?: React.CSSProperties;
    subtitle?: React.CSSProperties;
  };
};

export const HeaderContent = ({
  titleIntlId,
  titleIntlValues,
  subtitle,
  article,
  video,
  styles,
}: HeaderContentProps) => {
  return (
    <Grid container direction="column" wrap="nowrap" style={styles?.container ?? {}}>
      <Text variant="h5" intlId={titleIntlId} intlValues={titleIntlValues} style={styles?.title ?? {}} />

      {subtitle ? (
        <Text variant="body" intlId={subtitle} style={{ margin: `8px 0`, ...(styles?.subtitle ?? {}) }} />
      ) : (
        <VSpacer small />
      )}

      <Grid container direction="row">
        {article !== undefined ? (
          <>
            <Text
              variant="button"
              onClick={() => {
                if (article.onClick) {
                  article.onClick();
                  return;
                }

                if (article.link) window.open(article.link, `_blank`);
              }}
            >
              <Grid container alignItems="center">
                <img alt="" src={InfoIcon} width="14px" draggable="false" />

                <div style={{ width: `6px` }} />

                <Text tagName="span" variant="button" intlId={article.intlId} />
              </Grid>
            </Text>

            <HSpacer small />
          </>
        ) : null}

        {video !== undefined ? (
          <Text
            variant="button"
            onClick={() => {
              if (video.onClick) {
                video.onClick();
                return;
              }

              if (video.link) window.open(video.link, `_blank`);
            }}
          >
            <Grid container alignItems="center">
              <img alt="" src={VideosIconSvg} />

              <div style={{ width: `4px` }} />

              <Text tagName="span" variant="button" intlId={video.intlId} />
            </Grid>
          </Text>
        ) : null}
      </Grid>
    </Grid>
  );
};
